export function formatQuizScore(score) {
  if (score === null || score === undefined || score === "") return null;
  const value = Number(score);
  if (!Number.isFinite(value)) return null;
  return `${Math.round(value)}%`;
}
